import type { FC } from "react";

import { Badge, type BadgeProps, LightningBoltIcon } from "@hightouch/htui";

type RealtimeBadgeProps = {
  size?: BadgeProps["size"];
};

/**
 * "Realtime" pill shown wherever a realtime audience or journey appears. Only
 * the icon is blue, so the pill does not compete with the status badge beside it.
 */
export const RealtimeBadge: FC<Readonly<RealtimeBadgeProps>> = ({ size }) => (
  <Badge
    size={size}
    svgIcon={LightningBoltIcon}
    iconColor="primary.base"
    variant="ghost"
  >
    Realtime
  </Badge>
);
